import { useEffect, useState } from 'react'

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  })

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: global.innerWidth,
        height: global.innerHeight,
      })
    }

    global.addEventListener('resize', handleResize)
    handleResize()

    return () => global.removeEventListener('resize', handleResize)
  }, [])

  return windowSize
}

export default useWindowSize
